import { render } from "./SmartDashboard.vue?vue&type=template&id=f3458de6&scoped=true"
import script from "./SmartDashboard.vue?vue&type=script&lang=js"
export * from "./SmartDashboard.vue?vue&type=script&lang=js"

import "./SmartDashboard.vue?vue&type=style&index=0&id=f3458de6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3458de6"]])

export default __exports__